import './assets/sass/main.scss';
import RoutedApp from './routes/routes';
import 'rsuite/dist/rsuite.min.css';
import {Toasts} from './components';

function App() {
  return (
    <>
      <Toasts />
      <RoutedApp />
    </>
  );
}

export default App;
